<template>
  <v-row class="pagination-wrapper">
    <v-col cols="12" class="d-flex text-center">
      <v-btn class="mr-1" @click="applyPage(1)" :disabled="isFirstPage || disabled" x-small>
        <v-icon small>
          mdi-chevron-double-left
        </v-icon>
      </v-btn>
      <v-btn @click="applyPage(prePage)" :disabled="!hasPrePage || disabled" x-small>
        <v-icon small>
          mdi-chevron-left
        </v-icon>
      </v-btn>
      <span class="text">Page</span>
      <v-text-field type="number" @keyup.enter="applyPage($event.target.value)" :value="page" :disabled="disabled" class="shrink input" outlined dense hide-details></v-text-field>
      <span v-show="!dense" class="text">
        <span class="mr-1">of</span>
        {{ formatNumber(totalPages) }}
      </span>
      <v-btn @click="applyPage(nextPage)" :disabled="!hasNextPage || disabled" class="mr-1" x-small>
        <v-icon small>
          mdi-chevron-right
        </v-icon>
      </v-btn>
      <v-btn @click="applyPage(totalPages)" :disabled="isLastPage || disabled" class="mr-1" x-small>
        <v-icon small>
          mdi-chevron-double-right
        </v-icon>
      </v-btn>
      <v-btn :disabled="disabled" :loading="disabled" @click="emit()" class="mx-3" x-small>
        <v-icon small>
          mdi-refresh
        </v-icon>
        <template v-slot:loader>
          <span class="loader">
            <v-icon light small>mdi-cached</v-icon>
          </span>
        </template>
      </v-btn>
      <v-select v-model="rowsPerPage" :items="[20, 50, 100]" :disabled="disabled" class="shrink select" outlined dense hide-details></v-select>
      <span v-show="!dense" class="text">
        <span class="mr-1">Displaying</span>
        {{ formatNumber(startRow) }} - {{ formatNumber(endRow) }}
        <span class="mx-1">of</span>
        {{ formatNumber(length) }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    paging: {
      type: Object,
      required: true,
    },
    length: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Width가 좁은 grid의 footer로 표현될 때 축약형을 보여주기 위해 추가.
    // 2020.12.31.KWShin.
    dense: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: this.paging.page,
      rowsPerPage: this.paging.rowsPerPage,
    };
  },
  computed: {
    isFirstPage() {
      return this.page <= 1;
    },
    hasPrePage() {
      return this.page - 1 >= 1;
    },
    hasNextPage() {
      return this.page + 1 <= this.totalPages;
    },
    prePage() {
      return this.hasPrePage ? this.page - 1 : this.page;
    },
    nextPage() {
      return this.hasNextPage ? this.page + 1 : this.page;
    },
    isLastPage() {
      return this.page >= this.totalPages;
    },
    totalPages() {
      if (this.length <= 0) {
        return 0;
      }
      if (this.rowsPerPage <= 0) {
        return 0;
      }

      let count = this.length / this.rowsPerPage;
      if (this.length % this.rowsPerPage > 0) {
        count++;
      }
      return Math.floor(count);
    },
    startRow() {
      if (this.rowsPerPage <= 0 || this.length <= 0) {
        return 0;
      }
      return this.page > 0 ? (this.page - 1) * this.rowsPerPage + 1 : 0;
    },
    endRow() {
      return this.page > 0 ? Math.min(this.rowsPerPage * this.page, this.length) : 0;
    },
  },
  watch: {
    paging: {
      deep: true,
      handler(value) {
        this.page = value.page;
      },
    },
    rowsPerPage() {
      if (this.page > this.totalPages) {
        this.page = this.totalPages;
      }
      this.emit();
    },
  },
  methods: {
    applyPage(value) {
      this.page = value > this.totalPages ? this.totalPages : value;
      this.emit();
    },
    formatNumber(value) {
      return value.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
    },
    emit() {
      this.$emit('update:paging', { page: this.page, rowsPerPage: this.rowsPerPage });
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination-wrapper {
  padding: 4px;
}
.input {
  width: 60px !important;
}
.select {
  width: 75px !important;
}
.text {
  line-height: 23px;
  margin: 0 12px 0 12px;
}
.text-sapcing {
  letter-spacing: 2px;
}
.loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
